import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

class BtnCellRenderer extends Component {
  constructor(props) {
    super(props);
    console.log(this.props);

    this.clickBtn = this.clickBtn.bind(this);

    this.state = {
      controlBTN: this.props.data.Confirm === 1 ? true : false,
      list:[]
    }

  }

  componentDidMount(){
    if(this.props.context.length>0){
      this.setState({
      list:JSON.parse(this.props.context)
    })
    }
    
  }

  clickBtn(e) {

    


    var kapsayici_div = e.target.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.firstElementChild.nextElementSibling.nextElementSibling.nextElementSibling;
    console.log(kapsayici_div);
    kapsayici_div.parentElement.firstElementChild.nextElementSibling.nextElementSibling.classList.toggle("pop_up_noti_active")

    var newData=[];
    var id_temp = e.target.parentElement.parentElement.firstElementChild.textContent
    console.log(id_temp);
    for(let i=0;i<this.state.list.length;i++){
      if(String(this.state.list[i].id)===String(id_temp)){
        newData.push(this.state.list[i])
      }
    }
    console.log(newData);
    kapsayici_div.setAttribute("data-message",`${newData[0].message}`)
    kapsayici_div.setAttribute("data-tagName",`${newData[0].tagName}`)
    kapsayici_div.setAttribute("data-statusCode",`${newData[0].statusCode}`)
    kapsayici_div.setAttribute("data-id",`${String(newData[0].id)}`)
    kapsayici_div.setAttribute("data-id_tag",`${String(newData[0].tagId)}`)
    kapsayici_div.setAttribute("data-confirm",`${newData[0].confirm_}`)
    kapsayici_div.setAttribute("data-date",`${newData[0].date}`)
    kapsayici_div.setAttribute("data-tagValue",`${newData[0].tagValue}`)

    this.setState({
      controlBTN: !this.state.controlBTN
    })

    const updateNotification = async () =>{

      try{
        console.log(newData);
        const request = await fetch("https://app-rmmsapi.azurewebsites.net/api/tags/EditNotification",{
          method:"POST",
          headers:{
            "accept":"application/json",
            "Content-Type":"application/json"
          },
          body:JSON.stringify({
            "Message":newData[0].message,
            "StatusCode":newData[0].statusCode,
            "ID":newData[0].id,
            "TagId":newData[0].tagId,
            "TagValue":newData[0].tagValue,
            "TagName":newData[0].tagName,
            "CompanyID":Number(this.props.ucer_id),
            "Date":newData[0].date,
            "Confirm_":newData[0].confirm_===1?0:1
          })
        })
        const response = await request.json()

        if(request.status===200){
          console.log(response);
        }

      }catch(err){
        console.log(err);
      }
    }

    updateNotification()
  }

 

  render() {
    return (
      <>
        {this.state.controlBTN ? <button onClick={(e)=>{this.clickBtn(e)}}>Completed</button> : <button style={{ backgroundColor: "brown", borderColor: "brown" }} onClick={this.clickBtn}>Incompleted</button>}
      </>
    )

  }
}
const MapStateToProps = (state) => {
  return {
      ucer_id: state.project_reducer.company_id
  }
}

export default connect(MapStateToProps)(BtnCellRenderer)
